//-------------------------------------------------------------------------
// Temporary custom Tab pending proper re-factoring of application theme
//-------------------------------------------------------------------------

// TODO: Move these styling changes to a global theme override (affecting
//       MuiTab) so that the standard Tab class will be properly
//       themed with Nuvoola's theme.
// TODO: Once the above is done:
//       - Replace all instances of NuvTab with Tab.
//       - Delete this file.

import { withStyles } from "@material-ui/styles";
import Tab from "@material-ui/core/Tab";
import colors from "../../assets/style/colors";

const NuvTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        fontWeight: "400",
        color: colors.black54,
    },
    selected: {
        fontWeight: "500",
        color: colors.black87,
    },
}))(Tab);

export default NuvTab;